import { FC } from 'react';
import { Input, Switch } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { PlatformForm as Form } from '@/shared/components/forms';

const PublicIntegrationDetailsSection: FC = () => {
    const { token } = useAntDesignTheme();

    return (
        <>
            <Form.Item
                label='Application Overview'
                name='overview'
                rules={[{ max: 5000, message: 'Use no more than 5,000 characters' }]}
            >
                <Input.TextArea
                    rows={5}
                    showCount
                    maxLength={5000}
                    style={{ resize: 'none' }}
                    placeholder='Describe The Integration, Its Workflows, And The Value It Provides...'
                />
            </Form.Item>
            <Form.Item
                name='isPublic'
                valuePropName='checked'
                label='Public Integration'
                extra='Public applications can be submitted for review after creation.'
            >
                <Switch />
            </Form.Item>
        </>
    );
};

export default PublicIntegrationDetailsSection;
